import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { routes } from "Projects/config/routes";
import { getRelativePath } from "Utils";
const {
  casInsights: { path },
} = routes;
export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./CasInsights"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
    onEnter: (nextState, replace) => {
      const pathname = _.get(nextState, "location.pathname", "");
      const currentRoute = _.last(pathname.split("/"));
      if (_.isEqual(currentRoute, "casInsights")) {
        replace(getRelativePath("./portfolioInsights", "casInsights"));
      }
    },
  };
};
